import * as React from 'react'
import { NumberInputContainer } from './styles'
import { InputNumber } from 'antd'

interface NumberInputProps {
  id?: string
  value?: number
  spanAddonBefore?: string
  spanAddonAfter?: string
  onAddonBeforeClick?: () => void
  onAddonAfterClick?: () => void
  onChange?: (value: number | undefined | null) => void
  disabled?: boolean
  placeholder?: string
  error?: string
  controls?: boolean
}

const NumberInput = ({
  id,
  value,
  spanAddonBefore,
  spanAddonAfter,
  onAddonBeforeClick,
  onAddonAfterClick,
  onChange,
  placeholder,
  disabled,
  error,
  controls,
}: NumberInputProps) => {
  const handlePreventKeys = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (['-', '+', 'e', '.'].includes(e.key)) {
      e.preventDefault()
    }
  }

  return (
    <NumberInputContainer id="nova-shared-Number-Input-Container-root" error={!!error} value={value ?? 0}>
      <InputNumber
        id={id}
        value={value}
        addonBefore={
          <div id="nova-shared-Number-Input-Container-button-before" onClick={onAddonBeforeClick}>
            {spanAddonBefore}
          </div>
        }
        addonAfter={
          <div id="nova-shared-Number-Input-Container-button-after" onClick={onAddonAfterClick}>
            {spanAddonAfter}
          </div>
        }
        inputMode="numeric"
        type="number"
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        controls={controls}
        onPressEnter={(e) => (e.target as HTMLElement).blur()}
        onKeyDown={handlePreventKeys}
      />
      <div className="error-placeholder">{error && <div className="error">{error}</div>}</div>
    </NumberInputContainer>
  )
}

export default NumberInput
